import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/sections/Hero";
import AffiliationMarquee from "../components/sections/AffiliationMarquee";
import Manifesto from "../components/sections/Manifesto";
import AreasOfExpertise from "../components/sections/AreasOfExpertise";
import TestimonialsPreview from "../components/sections/TestimonialsPreview";
import Contact from "../components/sections/Contact";
import { scrollToId } from "../components/Navbar";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => scrollToId(location.state.scrollTo), 300);
    }
  }, [location.state]);

  return (
    <div data-testid="home-page">
      <Hero />
      <AffiliationMarquee />
      <Manifesto />
      <AreasOfExpertise />
      <TestimonialsPreview />
      <Contact />
    </div>
  );
}
